export default __webpack_public_path__ + "static/media/features-mock-slide1-map@2x.4a9f4ca2.png";